module.exports = __webpack_public_path__ + "img/376-54ba0e.png";